/** URL `?tab=` values for enquiry overview. */
export const EnquiryOverviewTabParam = {
  OVERVIEW: "overview",
  SITE_VISITS: "site-visits",
} as const;

export type EnquiryOverviewTabParamValue =
  (typeof EnquiryOverviewTabParam)[keyof typeof EnquiryOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, EnquiryOverviewTabParamValue> = {
  "1": EnquiryOverviewTabParam.OVERVIEW,
  "2": EnquiryOverviewTabParam.SITE_VISITS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [EnquiryOverviewTabParam.OVERVIEW]: "1",
  [EnquiryOverviewTabParam.SITE_VISITS]: "2",
};

export function enquiryOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForEnquiryOverviewTabId(
  tabId: string,
): EnquiryOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidEnquiryOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
